import { FC, ReactNode } from 'react'
import { DesktopSidebar } from './DesktopSidebar'
// import { DesktopSidebar } from './DesktopSidebar'

export const SideBar: FC<{ children: ReactNode }> = ({ children }) => {
  // NOTE: conditionally render MobileSidebar here if you need
  return <DesktopSidebar>{children}</DesktopSidebar>
}
